import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RefundsService {


  getTopicOptions() {
    return [
      {
        id: 1,
        name: 'Select one',
			  disabled: true,
      },
      {
        id: 2,
        name: 'Reissue my refund',
			  disabled: false,
      },
      {
        id: 3,
        name: 'Question about my refund',
			  disabled: false,
      },
    ]
  }

  getReasonOptions() {
    return [
      "Reissue my refund",
      "Question about my refund"
    ];
  }
  getReissueRefundOptions() {
    return [
      {
        id: 1,
        name: 'Select one',
			  disabled: true,
      },
      {
        id: 2,
        name: 'Unable to cash (expired check)',
			  disabled: false,
      },
      {
        id: 3,
        name: 'Received uncashed refund letter',
			  disabled: false,
      },
      {
        id: 4,
        name: 'New payee',
			  disabled: false,
      },
      {
        id: 5,
        name: 'Lost check',
			  disabled: false,
      },
    ]
  }
  getQuestionAboutRefundOptions() {
    return [
      {
        id: 1,
        name: 'Select one',
			  disabled: true,
      },
      {
        id: 2,
        name: 'Amount',
			  disabled: false,
      },
      {
        id: 3,
        name: 'Status',
			  disabled: false,
      }
    ]
  }
}
